var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 48,
    viewBox: "0 0 138 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8256 33.7882H2V14.2109H11.8256C17.2415 14.2109 21.6513 18.6056 21.6513 24.0029C21.6513 29.4003 17.2415 33.7949 11.8256 33.7949V33.7882ZM5.18742 30.6117H11.8256C15.4858 30.6117 18.4638 27.6438 18.4638 23.9962C18.4638 20.3486 15.4858 17.3807 11.8256 17.3807H5.18742V30.6117Z",
    fill: "#004098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.386 22.4062H47.5761V25.5828H61.386V22.4062Z",
    fill: "url(#paint0_linear_6040_17398)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2211 33.7871H56.3955C50.9796 33.7871 46.5699 29.3925 46.5699 23.9951C46.5699 18.5977 50.9796 14.2031 56.3955 14.2031H66.2211V17.3796H56.3955C52.7354 17.3796 49.7573 20.3475 49.7573 23.9951C49.7573 27.6427 52.7354 30.6106 56.3955 30.6106H66.2211V33.7871Z",
    fill: "#004098"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.287 33.7882H117.146V30.6117H130.287C131.678 30.6117 132.813 29.4878 132.813 28.1014C132.813 26.7151 131.678 25.5844 130.287 25.5844H122.055C118.908 25.5844 116.349 23.0338 116.349 19.8977C116.349 16.7616 118.908 14.2109 122.055 14.2109H135.196V17.3874H122.055C120.664 17.3874 119.529 18.5113 119.529 19.8977C119.529 21.284 120.664 22.4147 122.055 22.4147H130.287C133.434 22.4147 135.993 24.9653 135.993 28.1014C135.993 31.2376 133.434 33.7882 130.287 33.7882Z",
    fill: "#004098"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2677 33.7884H39.6345L34.2321 23.9964L37.0279 22.4688L43.2677 33.7884Z",
    fill: "url(#paint1_linear_6040_17398)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2232 25.5834H24.2849V14.2031H38.2232C41.3701 14.2031 43.9295 16.7538 43.9295 19.8899C43.9295 23.026 41.3701 25.5766 38.2232 25.5766V25.5834ZM27.4724 22.4069H38.2232C39.6143 22.4069 40.742 21.2762 40.742 19.8899C40.742 18.5035 39.6075 17.3796 38.2232 17.3796H27.4724V22.4069Z",
    fill: "#004098"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4724 22.4062H24.2849V33.7865H27.4724V22.4062Z",
    fill: "#004098"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.364 27.6093L97.2985 17.4L97.2445 33.7873H94.0571V17.5414C94.0571 15.8858 95.2591 14.3985 96.9136 14.2235C98.3857 14.0687 99.7228 14.8898 100.256 16.229L103.876 25.3278L107.448 16.3569C107.921 15.1792 109.001 14.2976 110.271 14.2101C112.142 14.0889 113.702 15.5695 113.702 17.4068V33.7806H110.514V17.4135L106.415 27.6227C105.503 29.8974 102.262 29.8974 101.357 27.616L101.364 27.6093Z",
    fill: "#004098"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.883 25.3264L107.455 16.3555L110.521 17.4053L107.34 25.3197C106.726 26.8541 104.524 26.8945 103.903 25.3668L103.883 25.3197V25.3264Z",
    fill: "url(#paint2_linear_6040_17398)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4874 34.9907C72.4677 34.9907 71.4412 34.7148 70.5093 34.1495C69.2195 33.3554 68.3213 32.1104 67.9769 30.6365C67.6325 29.1694 67.8756 27.6484 68.6725 26.3698L75.3175 15.676C76.9652 13.0311 80.4632 12.2101 83.1239 13.8454C85.7846 15.4875 86.6085 18.9736 84.9608 21.6252L78.3158 32.319C77.2421 34.0418 75.385 34.9907 73.4874 34.9907ZM80.1459 16.1673C79.3152 16.1673 78.4981 16.5845 78.0322 17.3383L71.3872 28.032C71.036 28.5974 70.928 29.2569 71.0833 29.903C71.2386 30.549 71.6303 31.0941 72.1908 31.4374C72.7581 31.7873 73.4199 31.895 74.0681 31.7402C74.7164 31.5922 75.2634 31.1951 75.6146 30.6365L82.2595 19.9427C82.9821 18.7852 82.6175 17.2508 81.4559 16.5374C81.0508 16.2884 80.5983 16.1673 80.1526 16.1673H80.1459Z",
    fill: "#004098"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7976 34.9982C86.3586 34.9982 85.9197 34.951 85.4875 34.8434C84.0153 34.5001 82.7593 33.5983 81.9624 32.3197L75.3174 21.6259C74.5206 20.3405 74.2707 18.8262 74.6219 17.3591C74.9663 15.892 75.8712 14.647 77.1543 13.8461C79.815 12.204 83.313 13.0251 84.9607 15.6767L91.6057 26.3704C92.4026 27.6559 92.6524 29.1701 92.3013 30.6372C91.9569 32.1043 91.052 33.3561 89.7689 34.1502C88.864 34.7088 87.8375 34.9982 86.7976 34.9982ZM80.1391 16.1747C79.6934 16.1747 79.2409 16.2958 78.8358 16.5448C78.2685 16.8948 77.8768 17.4399 77.7283 18.086C77.573 18.732 77.6878 19.3916 78.0322 19.9569L84.6771 30.6507C85.0283 31.216 85.5753 31.6063 86.2236 31.7544C86.8719 31.9091 87.5336 31.7947 88.1009 31.4515C88.6682 31.1016 89.0598 30.5564 89.2084 29.9104C89.3637 29.2643 89.2489 28.6048 88.9045 28.0395L82.2595 17.3457C81.7868 16.5919 80.9765 16.1747 80.1459 16.1747H80.1391Z",
    fill: "#004098"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9337 21.6598L82.0164 26.3573L80.1458 23.3423L82.246 19.9504C82.7863 19.0823 82.7255 18.0189 82.1718 17.2383C82.2055 17.2719 82.2258 17.3123 82.2528 17.346L84.927 21.6531L84.9337 21.6598Z",
    fill: "url(#paint3_linear_6040_17398)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2016 29.9108C89.3637 29.2647 89.2489 28.5985 88.8977 28.0399L84.9337 21.66L84.9607 21.6196C86.1425 19.7285 86.0547 17.4067 84.9337 15.6367C84.9472 15.6502 84.9607 15.6636 84.9675 15.6771L91.6125 26.3776C92.4093 27.6563 92.6592 29.1705 92.3148 30.6376L89.2084 29.9175L89.2016 29.9108Z",
    fill: "url(#paint4_linear_6040_17398)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4941 31.8134C73.6832 31.8134 73.8655 31.7999 74.0614 31.7528C74.7164 31.6048 75.2567 31.2077 75.6078 30.6424L78.2685 26.3555L80.1391 29.3772L78.3158 32.3114C77.2488 34.0343 75.385 34.9832 73.4874 34.9832V31.8067L73.4941 31.8134Z",
    fill: "url(#paint5_linear_6040_17398)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6040_17398",
    x1: 60.9403,
    y1: 23.9945,
    x2: 50.9391,
    y2: 23.9945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6040_17398",
    x1: 41.0797,
    y1: 33.2029,
    x2: 37.3785,
    y2: 26.3144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6040_17398",
    x1: 108.481,
    y1: 18.7177,
    x2: 105.224,
    y2: 25.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6040_17398",
    x1: 83.1779,
    y1: 20.61,
    x2: 80.4802,
    y2: 23.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6040_17398",
    x1: 90.6333,
    y1: 28.1274,
    x2: 85.438,
    y2: 20.2639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6040_17398",
    x1: 75.6146,
    y1: 32.1566,
    x2: 78.6966,
    y2: 29.0032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a2c3c4aef8b5975829a3ca0b62450dc6.svg";
export { ForwardRef as ReactComponent };